module.exports = __webpack_public_path__ + "/images/cover-mujeres-consultando-ordenador-800.66e12ea.jpg";